package fr.frux.shared.dto

import kotlinx.serialization.Serializable

/** Catégorie d'un retour utilisateur (#437, ADR 0028). */
@Serializable
enum class FeedbackCategoryDto { BUG, IDEA, OTHER }

/**
 * Corps de `POST /api/v1/feedback` (#437, ADR 0028). Les bornes vivent dans [fr.frux.shared.content.FeedbackLimits],
 * partagées entre le compteur du formulaire et la validation serveur.
 */
@Serializable
data class CreateFeedbackRequest(
    val category: FeedbackCategoryDto,
    val message: String,
    val appVersion: String,
    val platform: String,
    val sourceScreen: String,
)
